// src/components/landing/CoursesCarousel.jsx
import React from 'react';
import { Box, Typography, Button, Grid } from '@mui/material';
import { motion } from 'framer-motion';
import img_course_dca from '../../assets/images/landing/course-dca.jpg';
import img_course_hardware from '../../assets/images/landing/course-hardware.jpg';
import img_course_office from '../../assets/images/landing/course-office.jpg';
import img_course_tally from '../../assets/images/landing/course-tally.jpg';
import img_course_web from '../../assets/images/landing/course-web.jpg';
const COURSES = [
  { img: img_course_dca,      tag: 'Popular',       title: 'DCA — Diploma in Computer Applications', desc: 'Government of Kerala has approved the DCA Course for the purpose of appointment to suitable posts in public services.', duration: '6 Months' },
  { img: img_course_office,   tag: 'Career Track',  title: 'MS Office Professional',                  desc: 'KGTE Word Processing equivalent. Ideal for LD Typist and government clerical roles.', duration: '3 Months' },
  { img: img_course_web,      tag: 'New',           title: 'Web Design & Development',               desc: 'HTML, CSS, JavaScript — hands-on training for modern web careers.', duration: '4 Months' },
  { img: img_course_tally,    tag: 'Finance',       title: 'Tally & Financial Accounting',            desc: 'Complete accounting software training for business and finance careers.', duration: '3 Months' },
  { img: img_course_hardware, tag: 'Hardware',      title: 'Hardware & Networking',                   desc: 'Build, repair, and maintain computers. Covers networking and troubleshooting.', duration: '6 Months' },
];

const TAG_COLORS = {
  Popular:      { bg: '#fff3e0', color: '#e65100', border: '#ffe0b2' },
  'Career Track':{ bg: '#e3f2fd', color: '#1565c0', border: '#bbdefb' },
  New:          { bg: '#e8f5e9', color: '#2e7d32', border: '#c8e6c9' },
  Finance:      { bg: '#f3e5f5', color: '#6a1b9a', border: '#e1bee7' },
  Hardware:     { bg: '#e0f7fa', color: '#00695c', border: '#b2dfdb' },
};

export default function CoursesCarousel() {
  return (
    <Box id="courses" sx={{ bgcolor: '#f0f7ff', py: { xs: 8, md: 12 }, px: { xs: 3, md: 8 } }}>
      <Box sx={{ textAlign: 'center', mb: 7, maxWidth: 680, mx: 'auto' }}>
        <Typography sx={{ fontSize: '0.68rem', fontWeight: 700, letterSpacing: 3, textTransform: 'uppercase', color: '#1d6cf0', mb: 1 }}>
          Programs
        </Typography>
        <Typography sx={{ fontSize: { xs: '1.7rem', md: '2.3rem' }, fontWeight: 900, letterSpacing: '-0.5px', color: '#1e293b', lineHeight: 1.2 }}>
          Courses Designed for Real Careers
        </Typography>
        <Typography sx={{ color: '#64748b', fontSize: '0.95rem', mt: 1.5, lineHeight: 1.75 }}>
          Government-approved programs designed to get you employed, not just certified.
        </Typography>
      </Box>

      <Grid container spacing={3} sx={{ maxWidth: 1200, mx: 'auto' }}>
        {COURSES.map((c, i) => {
          const tc = TAG_COLORS[c.tag] || TAG_COLORS.New;
          return (
            <Grid item xs={12} sm={6} md={4} key={c.title}>
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                style={{ height: '100%' }}
              >
                <Box sx={{
                  bgcolor: '#fff', borderRadius: 4, overflow: 'hidden',
                  border: '1px solid #e2eaf5',
                  boxShadow: '0 4px 20px rgba(29,108,240,0.07)',
                  display: 'flex', flexDirection: 'column', height: '100%',
                  transition: 'transform 0.25s, box-shadow 0.25s',
                  '&:hover': { transform: 'translateY(-6px)', boxShadow: '0 16px 40px rgba(29,108,240,0.15)', borderColor: '#93c5fd' },
                }}>
                  <Box sx={{ height: 200, position: 'relative', overflow: 'hidden', flexShrink: 0 }}>
                    <Box component="img" src={c.img} alt={c.title}
                      sx={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block',
                        transition: 'transform 0.4s', '&:hover': { transform: 'scale(1.04)' } }} />
                    <Box sx={{
                      position: 'absolute', top: 12, right: 12,
                      bgcolor: tc.bg, border: `1px solid ${tc.border}`,
                      color: tc.color, px: 1.5, py: 0.4, borderRadius: 10,
                      fontSize: '0.72rem', fontWeight: 700,
                    }}>
                      {c.tag}
                    </Box>
                  </Box>
                  <Box sx={{ p: 3, display: 'flex', flexDirection: 'column', flex: 1 }}>
                    <Typography sx={{ fontSize: '1rem', fontWeight: 800, color: '#1e293b', mb: 1, lineHeight: 1.3 }}>{c.title}</Typography>
                    <Typography sx={{ fontSize: '0.83rem', color: '#64748b', lineHeight: 1.65, mb: 2, flex: 1 }}>{c.desc}</Typography>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 'auto' }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                        <Typography sx={{ fontSize: '0.78rem', color: '#94a3b8', fontWeight: 600 }}>{c.duration}</Typography>
                      </Box>
                      <Button size="small" sx={{
                        color: '#1d6cf0', bgcolor: '#eff6ff',
                        border: '1px solid #bfdbfe', borderRadius: 2,
                        fontSize: '0.78rem', fontWeight: 700, textTransform: 'none', px: 2, py: 0.5,
                        '&:hover': { bgcolor: '#dbeafe', borderColor: '#93c5fd' },
                      }}>
                        Learn More
                      </Button>
                    </Box>
                  </Box>
                </Box>
              </motion.div>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
}
